import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { contestEntriesBackend } from './contest-entries.backend';
import { contestEntriesReducer } from './contest-entries.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('contestEntries', contestEntriesReducer),
    BackendModule.forFeature('contestEntries', contestEntriesBackend),
  ],
})
export class DatastoreContestEntriesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contest-entries/contest-entries.module.ts